var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
const SvgElo = _a => {
  var {
      size
    } = _a,
    props = __rest(_a, ["size"]);
  return React.createElement("svg", Object.assign({
    width: size || 24,
    height: size || 24,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: props.role,
    "aria-hidden": props['aria-hidden'] || true
  }, props), React.createElement("rect", {
    y: -0.00000762939,
    width: 32,
    height: 32,
    rx: 16,
    fill: "black"
  }), React.createElement("path", {
    d: "M21.2632 14.6223C21.5057 14.5429 21.7644 14.5006 22.0328 14.5006C23.2078 14.5006 24.1887 15.3195 24.4129 16.4081L26.0783 16.0749C25.6967 14.2255 24.0302 12.8333 22.0328 12.8333C21.5747 12.8333 21.136 12.9063 20.7242 13.0417L21.2632 14.6223Z",
    fill: "#FFCB05"
  }), React.createElement("path", {
    d: "M19.2913 19.9006L20.411 18.6526C19.9117 18.2162 19.5967 17.579 19.5967 16.8689C19.5967 16.1598 19.9117 15.5226 20.411 15.0872L19.2913 13.8382C18.4427 14.58 17.907 15.6631 17.907 16.8689C17.907 18.0756 18.4427 19.1588 19.2913 19.9006Z",
    fill: "#00A4E0"
  }), React.createElement("path", {
    d: "M24.4129 17.3471C24.1876 18.4304 23.2078 19.2449 22.0339 19.2449C21.7644 19.2449 21.5047 19.2027 21.2632 19.1226L20.7242 20.699C21.136 20.8328 21.5758 20.9055 22.0339 20.9055C24.0292 20.9055 25.6946 19.5209 26.0783 17.6812L24.4129 17.3471Z",
    fill: "#EF4123"
  }), React.createElement("path", {
    d: "M6.6268 19.0099C6.53698 18.8654 6.41722 18.6347 6.34325 18.4639C5.91176 17.4635 5.89239 16.428 6.25519 15.4347C6.65498 14.3445 7.41934 13.5115 8.40736 13.0852C9.64899 12.5516 11.021 12.6555 12.2115 13.3618C12.9671 13.795 13.5025 14.4643 13.9093 15.4118C13.9604 15.5333 14.0062 15.6619 14.052 15.7728L6.6268 19.0099ZM9.10655 14.6932C8.2242 15.0719 7.76981 15.8996 7.86492 16.8683L11.5986 15.2603C10.9558 14.5065 10.121 14.2564 9.10655 14.6932ZM12.0636 18.1909C12.0618 18.1909 12.0618 18.1927 12.0618 18.1927L11.9843 18.1398C11.7607 18.5009 11.4137 18.795 10.9752 18.9852C10.1404 19.348 9.36721 19.2547 8.81067 18.7668L8.7596 18.8443C8.7596 18.8443 8.7596 18.8426 8.75784 18.8426L7.81032 20.2603C8.04632 20.4241 8.29817 20.5615 8.56234 20.6724C9.60849 21.1074 10.6793 21.0863 11.7342 20.6284C12.4968 20.2973 13.0956 19.7936 13.5042 19.1543L12.0636 18.1909Z",
    fill: "white"
  }), React.createElement("path", {
    d: "M16.6461 11V18.8795L17.8719 19.3762L17.1762 21L15.8236 20.4364C15.5207 20.3043 15.3129 20.1036 15.1579 19.8764C15.0082 19.6457 14.8972 19.3269 14.8972 18.9007V11H16.6461Z",
    fill: "white"
  }));
};
export default SvgElo;